var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fragment.src)?_c('div',{staticClass:"c-player-sprite"},[_c('div',{ref:"wrapper",staticClass:"c-player-sprite__img",style:(_vm.spriteStyles)})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }